import { useGlobalCurrency, useRiskExposure } from "@iliotech/data-wire";
import { useReportBespoke } from "@iliotech/data-wire";
import TimeSeriesLineChart from "@iliotech/widgets/src/components/TimeSeriesLineChart/TimeSeriesLineChart";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React from "react";
import { useParams } from "react-router-dom";
import { ReportWidgetProps } from "../../ReportWidgetProps";

export const DailyMarketValueVsExposureWidget = observer(
  ({ height, width, periodContext }: ReportWidgetProps) => {
    const store = useReportBespoke();
    const { generating } = store;
    const { portfolioId } = useParams<{ portfolioId: string }>();
    const periodString = periodContext.periodString;
    const { currencyFormatter } = useGlobalCurrency();
    const riskExposure = useRiskExposure({
      portfolioId: portfolioId!,
      frequency: "Daily",
      overridePeriod: periodContext.periodForRequest,
    });

    const riskExposureData = React.useMemo(() => {
      const rawData = riskExposure.data?.data?.marketValueAndExposure;

      if (!rawData || !Array.isArray(rawData)) {
        return [];
      }

      const categories: ("Market Value" | "Exposure")[] = [
        "Market Value",
        "Exposure",
      ];

      return categories.map((category) => ({
        category,
        entries: rawData.map((d) => ({
          date: new Date(d.date),
          value: category === "Market Value" ? d.mv : d.exp,
        })),
        color: category === "Market Value" ? "#e5422b" : "#23798a",
      }));
    }, [riskExposure?.data]);

    const categoryFormatter = (val: Date) => moment(val).format(`DD MMM 'YY`);
    return (
      <div>
        <h3 className={"element-title"}>{`Daily Market Value vs Exposure`}</h3>
        <p className={"period-string"}>{periodString}</p>
        <TimeSeriesLineChart
          height={height || 250}
          width={width}
          chartCategoryAxisItemProps={{
            labels: {
              rotation: "auto",
            },
          }}
          isPdf={generating}
          tooltipSettings={{
            hideTotal: true,
          }}
          categoryAxisFormatter={(e: string) =>
            categoryFormatter(e as unknown as Date)
          }
          valueAxisFormatter={currencyFormatter}
          items={riskExposureData}
        />
      </div>
    );
  }
);
